/**
 * Wrapper around global `cohesion` function.
 * @see https://redventures.atlassian.net/wiki/spaces/COHSN/pages/96711970265/Cohesion+Client+API
 */
export const cohesion = (eventName, ...args) => {
    if (typeof window !== 'undefined' && typeof window.cohesion === 'function') {
        return window.cohesion(eventName, ...args);
    }
    else {
        console.error('[cohesion-utils] window.cohesion is not defined');
    }
};
/**
 * Wrapper around global `tagular` function.
 * @see https://redventures.atlassian.net/wiki/spaces/COHSN/pages/99418865810/Client+API+-+Tagular
 */
export const tagular = (methodName, ...args) => {
    if (typeof window !== 'undefined' && typeof window.tagular === 'function') {
        return window.tagular(methodName, ...args);
    }
    else {
        console.error('[cohesion-utils] window.tagular is not defined');
    }
};
/**
 * Wrapper around global `monarch` function.
 * @see https://redventures.atlassian.net/wiki/spaces/COHSN/pages/1427145833/Client+API+-+Monarch
 */
export const monarch = (...args) => {
    cohesion('monarch:ready', () => {
        if (typeof window !== 'undefined' && typeof window.monarch === 'function') {
            window.monarch(...args);
        }
        else {
            console.error('[cohesion-utils] window.monarch is not defined');
        }
    });
};
